



















import Auth from '../comps/Auth'

export default
    components: {Auth}
    data: ->
        type: 'login' # signup, login
